import { render } from "./AnimalImage.vue?vue&type=template&id=264674d8"
import script from "./AnimalImage.vue?vue&type=script&lang=ts"
export * from "./AnimalImage.vue?vue&type=script&lang=ts"
script.render = render

export default script